export const Region = "us-east-1";
export const UserPoolId = "us-east-1_4kJuKh4xM";
export const ClientId = "28950sdthd94br3ung9tdfmro7";